import { makeModuleStateSelector } from "@client/content/selectors";
import { getMultiselectValue } from "@client/lib/settings";
import { createShallowEqualSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type CourseList } from "./types";

export const localStateSelector = makeModuleStateSelector<CourseList.AppState>(defaultState, previewState);

export const makeSearchTextSelector = () =>
  createSelector([localStateSelector], (localState): string | null => localState.searchText);

export const makeCourseIdsValueSelector = () => {
  const coursesSettingSelector = getSettingValueSelector(
    TargetSelector.Entity,
    "courses",
    undefined,
    getMultiselectValue
  );
  return createShallowEqualSelector([coursesSettingSelector], (courses) => (courses ?? []).filter((cid) => !!cid));
};

const isEnrolledPropsSelector = (state: any, props: { isEnrolled: boolean }) => props.isEnrolled;
export const makeAvailableCoursesSelector = () => {
  const courseIdsSelector = makeCourseIdsValueSelector();
  return createShallowEqualSelector(
    [localStateSelector, courseIdsSelector, isEnrolledPropsSelector],
    (localState, courseIds, isEnrolled) => {
      const courses = localState.availableCourses.filter((x) => x.isEnrolled === isEnrolled);
      return courseIds.length ? courses.filter((c) => courseIds.includes(c.id)) : courses;
    }
  );
};

export const makeFilteredCoursesSelector = () => {
  const availableCoursesSelector = makeAvailableCoursesSelector();
  const searchTextSelector = makeSearchTextSelector();

  return createShallowEqualSelector([availableCoursesSelector, searchTextSelector], (courses, searchText) => {
    if (!searchText) return courses;

    const stl = searchText.toLowerCase();
    return courses.filter((x) => x.name.toLowerCase().includes(stl));
  });
};
